import { useSiteContent } from "../../context/SiteContext";

export const Footer = () => {
  const content = useSiteContent();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#27272A] bg-[#0A0A0A]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-display font-black text-2xl">
            EFFORTLESS<span className="neon-text">.</span>METAPHOR
          </div>
          <p className="label-mono text-neutral-500 mt-3">
            {content.label.city}
          </p>
          <p className="text-neutral-400 text-sm mt-4 max-w-sm">
            {content.label.tagline}
          </p>
        </div>

        <div>
          <div className="label-mono text-neutral-500 mb-3">// Channels</div>
          <ul className="space-y-2">
            {content.label.socials.map((s) => (
              <li key={s.label}>
                <a
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-neutral-300 hover:text-neon transition-colors text-sm"
                >
                  → {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="label-mono text-neutral-500 mb-3">// Transmit</div>
          <a
            data-testid="footer-contact-email"
            href={`mailto:${content.label.contactEmail}`}
            className="text-neon text-sm break-all hover:underline"
          >
            {content.label.contactEmail}
          </a>
          <p className="text-neutral-500 text-xs mt-6 label-mono">
            © {new Date().getFullYear()} EFFORTLESS METAPHOR · ALL RIGHTS RESERVED
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
